import { SearchOutlined } from '@ant-design/icons';
import { Select, Space } from 'antd';
import SearchComponent from 'components/Global/SearchComponent';
import styles from './index.module.scss';
import DatePickerField from 'components/Global/BackAndForwardDatePicker';

type Props = {
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	dateValue: any;
	handleDatePicker: any;
	supervisorFilterValue: string;
	handleSupervisorFilter: (value: string) => void;
	supervisorOptions: any;
	supervisorsLoading: boolean;
	supervisorFromQuery: boolean;
	isDateDisable: boolean;
};

const TimeLogHeader = (props: Props) => {
	const {
		searchText,
		handleSearch,
		handleSearchApi,
		handleDatePicker,
		dateValue,
		supervisorFilterValue,
		supervisorOptions,
		handleSupervisorFilter,
		supervisorsLoading,
		supervisorFromQuery,
		isDateDisable,
	} = props;

	return (
		<div className={styles['time-logs-header']}>
			<Space>
				<SearchComponent
					className={styles['time-logs-header-item']}
					placeHolder="Search by code or name"
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
				<DatePickerField
					name="date"
					value={dateValue}
					onChange={handleDatePicker}
					showNavigationArrows={true}
					navigationStep="day"
					required={false}
					isError={false}
					disabled={isDateDisable}
				/>

				<Select
					className={styles['time-logs-header-item']}
					value={supervisorFilterValue}
					options={supervisorOptions}
					loading={supervisorsLoading}
					onChange={handleSupervisorFilter}
					size="large"
					placeholder="Select by supervisor"
					disabled={supervisorFromQuery}
				/>
			</Space>
		</div>
	);
};

export default TimeLogHeader;
